/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useEffect, useState } from 'react';
import './Legend.scss';

export default function LegendStatusItem({ colourData, size }) {
    const [textColour, setTextColour] = useState(false);
    const [backgroundColour, setBackgroundColour] = useState(false);
    const [outlineColour, setOutlineColour] = useState(false);

    useEffect(() => {
        if (colourData) {
            let borderType = colourData.HasDash ? 'dashed' : 'solid';
            setTextColour(colourData.TextCol);
            setBackgroundColour(colourData.FillCol);
            setOutlineColour(colourData.OutlineCol + ' ' + borderType + ' 0.9px');
            // setTypeOutline(safeCss(colourData.hasDash ? "dashed" : "solid"));
        }
    }, [colourData]);

    return (
        <>
            <div>
                <button
                    type="button"
                    className="project-status"
                    style={{ backgroundColor: backgroundColour, color: textColour, border: outlineColour }}
                >
                    {size}
                </button>
            </div>
        </>
    );
}
